import React from "react"
import { default as CompostableImg } from "../../../images/compostable_animation.gif"
import { default as ReusableImg } from "../../../images/reusable_animation.gif"
import { default as RecycleImg } from "../../../images/recyclable_animation.gif"
import CommunityImg from "../CommunityImg/CommunityImg"
import "./SustainabilityInfo.scss"
import { useWindowSize, getBreakpointValue } from "../../../utils/breakpoints"

const SustainabilityInfo = ({ productType }) => {
  const { width } = useWindowSize()
  const ProductInfo = {
    Compostable: {
      img: CompostableImg,
      color: "#697F6C",
      heading:
        "Compostable packaging is typically made from a number of renewable plant-based materials and/or bio-polymers.",
      subHeading:
        "To be certified home compostable, a product must break down in home compost within 180 days and 90 days in commercial composting conditions.",
      point_1_heading: "Why it’s awesome?",
      point_1_subHeading:
        "Cardboard and paper products are a great addition to the backyard compost as it helps with the carbon-nitrogen ratio. Easily broken down in a compost, these products also tend to have chemical compounds removed from the product.",
      point_2_heading: "Ensuring Success",
      point_2_subHeading:
        "Sometimes people don’t notice that something is compostable, meaning it can sometimes end up in the landfill. If you don’t have a home compost, you can look at local options for communal compost sites, or somewhere you can drop off items for commercial composting.",
    },
    Recycle: {
      img: RecycleImg,
      color: "#3A3A6E",
      heading:
        "Recycled packaging is made from previously used materials, including paper and plastic.",
      subHeading:
        "The plastic is processed at a recycling facility and put back into circulation, thus doubling its lifespan.",
      point_1_heading: "Why it’s awesome?",
      point_1_subHeading:
        "Recycling reduces the amount of waste sent to landfills and incinerators - it conserves natural resources and prevents pollution by reducing the need to collect new raw materials. Basically instead of making something new - we’re taking something already in circulation to give it a second life!",
      point_2_heading: "Ensuring Success",
      point_2_subHeading: `While operating and maintaining recycling plants can often be a bit more costly, you can support by choosing products made from recycled materials. When you're done with these products, make sure you recycle them in their appropriate categories e.g. plastics, aluminum, glass, paper etc. so it goes to the right plant and doesn't end up in the landfill.`,
    },
    Reusable: {
      img: ReusableImg,
      color: "#DE5F72",
      heading:
        "Reusable packaging is packaging that has a built-in second (and possibly third, fourth, etc.) use.",
      subHeading:
        "While most packaging is typically single use, and recycled after it accomplishes its primary goal, reusable packaging can be used multiple times for a variety of functions.",
      point_1_heading: "Why it’s awesome?",
      point_1_subHeading:
        "When an item of packaging is used for a second time after its initial use, that doubles the utility of the packaging, and prevents another single-use piece of packaging from being used.",
      point_2_heading: "Ensuring Success",
      point_2_subHeading:
        "In order for reusable packaging to have its desired impact, it has to be used more than once. Simply put, if a reusable bag is immediately discarded, it loses any potential positive benefits it might have had. To combat this, companies should focus on educating their customers on their packaging and how to make the most out of it.",
    },
  }

  return (
    <div className={`sustainability-info ${productType}`}>
      {width > getBreakpointValue("md") && (
        <CommunityImg
          className="sustainability-info-img"
          src={ProductInfo[productType].img}
          alt="CompostableImg"
          loading="lazy"
        />
      )}

      <div className="left-side">
        <div
          className="heading"
          style={{ color: ProductInfo[productType].color }}
        >
          {ProductInfo[productType].heading}
        </div>

        <div className="subheading">{ProductInfo[productType].subHeading}</div>
        {width < getBreakpointValue("md") && (
          <CommunityImg
            className="sustainability-info-img"
            src={ProductInfo[productType].img}
            alt="CompostableImg"
            loading="lazy"
          />
        )}

        <div className="sustainability-info-points first-point">
          <div
            className="point-heading"
            style={{ color: ProductInfo[productType].color }}
          >
            {ProductInfo[productType].point_1_heading}
          </div>
          <div className="point-details">
            {ProductInfo[productType].point_1_subHeading}
          </div>
        </div>
        <div className="sustainability-info-points">
          <div
            className="point-heading"
            style={{ color: ProductInfo[productType].color }}
          >
            {ProductInfo[productType].point_2_heading}
          </div>
          <div className="point-details">
            {ProductInfo[productType].point_2_subHeading}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SustainabilityInfo
